import { db } from "../firebase/firebase";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";

export const logActivity = async (type, productId) => {
  const id = Date.now().toString(); // unique
  const ref = doc(db, "analyticsActivity", id);

  await setDoc(ref, {
    type,          // "view", "click", "upload"
    productId,
    timestamp: serverTimestamp(),
  });
};
